/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            object: '=',
            objectForm: '=',
            showErrors: '=',
            classifiers: '=',
            accessibilities: '=',
            accessibilityDuplicatedError: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function() {
            let vm = this;

            vm.accessibilityClassifiers = [];
            vm.accessibilityLevelClassifiers = {};

            vm.$onInit = function() {
                vm.accessibilityClassifiers = vm.classifiers.accessibility;
                for(let i = 0; i < vm.accessibilityClassifiers.levels.length; i++) {
                    const level = vm.accessibilityClassifiers.levels[i];
                    if(!vm.accessibilityLevelClassifiers[level.parent_id]) {
                        vm.accessibilityLevelClassifiers[level.parent_id] = [];
                    }
                    vm.accessibilityLevelClassifiers[level.parent_id].push(level);
                }
                vm.accessibilities = $.map(vm.object.version.accessibility, function(item) {
                    return {
                        accessibility_group_classifier_id: item.accessibility_group_classifier_id,
                        accessibility_level_classifier_id: item.accessibility_level_classifier_id
                    };
                });
            };

            vm.addAccessibilityGroup = function() {
                this.accessibilities.push({});
            };

            vm.removeAccessibilityGroup = function(index) {
                if(window.confirm('Kas oled kindel?')) {
                    this.accessibilities.splice(index, 1);
                    vm.accessibilityDuplicatedError = false;
                }
            };

            vm.accessibilityGroupChanged = function(accessibility) {
                vm.accessibilityDuplicatedError = false;
                accessibility.accessibility_level_classifier_id = null;

                const accessibilityGroupIds = {};
                for(let i = 0; i < vm.accessibilities.length; i++) {
                    const accessibility = vm.accessibilities[i];
                    if(accessibilityGroupIds[accessibility.accessibility_group_classifier_id]) {
                        vm.accessibilityDuplicatedError = true;
                    }
                    accessibilityGroupIds[accessibility.accessibility_group_classifier_id] = true;
                }
            };

            vm.getAccessibilityName = function(id) {
                let name = '';
                for(let i = 0; i < vm.accessibilityClassifiers.groups.length; i++) {
                    if(vm.accessibilityClassifiers.groups[i].id === id) {
                        name = vm.accessibilityClassifiers.groups[i].name;
                        break;
                    }
                }
                return name;
            };

            vm.getAccessibilityLevelName = function(id) {
                let name = '';
                for(let i = 0; i < vm.accessibilityClassifiers.levels.length; i++) {
                    if(vm.accessibilityClassifiers.levels[i].id === id) {
                        name = vm.accessibilityClassifiers.levels[i].name;
                        break;
                    }
                }
                return name;
            };
        },

        template: require('./objects-edit-accessibilities.html')
    };
};




/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-accessibilities.directive.js
 **/